module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-GBEB_1.b03b3aa2.jpg";